import { clearTimer } from './clearTimer';
import { getMeasureMarkers } from './internal/utils';

export function stopTimer(event: string) {
  let performanceMeasures: PerformanceEntryList = [];
  const { measureName, startEvent, endEvent } = getMeasureMarkers(event);
  // If we never started the timer, we should not stop it. Otherwise,
  // the browser will through an error when trying to measure the duration.
  if (performance.getEntriesByName(startEvent).length > 0) {
    performance.mark(endEvent);

    performance.measure(measureName, startEvent, endEvent);
    performanceMeasures = performance.getEntriesByName(measureName, 'measure');

    clearTimer(event);
  }

  return performanceMeasures;
}
